import { render, staticRenderFns } from "./notifyStats.vue?vue&type=template&id=2a16ec68&scoped=true&lang=pug"
import script from "./notifyStats.vue?vue&type=script&lang=js"
export * from "./notifyStats.vue?vue&type=script&lang=js"
import style0 from "./notifyStats.vue?vue&type=style&index=0&id=2a16ec68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16ec68",
  null
  
)

export default component.exports